import { createGlobalStyle } from "styled-components";
import calender from 'assets/images/calender.svg'

export const SearchStyles = createGlobalStyle`
.search-container{
    width: 100%;
    background-color:var(--white);
    display: flex;
    gap: 2rem;
    padding: 2rem;
    border-radius: 1rem;
    justify-content: center;
    @media (max-width: 990px) {
        flex-wrap: wrap;
    }
}

.input-fields{
    width: 80%;
    display: flex;
    gap: 1.5rem;
 
     @media (max-width: 990px) {
       width: 100%;
       flex-wrap: wrap;
    }
}

input ,select{
    width: 100%;
    font-size: 1.8rem;
    /* color: var(--text); */
    color: black;
}

option{
    font-size: 1.6rem;
}

.search-cart{
    width: 100%;
    display: flex;
    gap: .5rem;
    align-items: center;
    background-color:#FFFFFF1A;
    border-radius: 1rem;
    border: 1px solid #E2E8F0;
    padding: 1rem;
}

.custom-date-input-container {
  position: relative;
  width: 100%;
}

.custom-date-input {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  height: 100%;
  padding-right: 30px; /* Give space for the custom icon */
  cursor: pointer;
}

/* Hide native icon without disabling functionality */
.custom-date-input::-webkit-calendar-picker-indicator {
  opacity: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  cursor: pointer;
}

/* Custom icon overlay */
.custom-date-input-container::after {
  content: '';
  background-image: url(${calender});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 20px 20px;
  width: 20px;
  height: 20px;
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none; /* Let input receive the click */
}

`;